import { Component, OnInit } from "@angular/core";
import { CMSPage } from "@app/core/data/CMSPage";
import { CMSDataControllerService } from "@app/core/data/controller/cmsdata-controller.service";
import { DeepLinkHelper } from "@app/core/data/utils/DeepLinkHelper";
import { CodebaseTranslateService } from "@app/services/codebase-translate.service";
import { environment } from "@env/environment";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-parking",
  templateUrl: "./parking.component.html",
  styleUrls: ["./parking.component.scss"],
})
export class ParkingComponent implements OnInit {
  public page!: CMSPage[];
  title: string;
  public language = this.translateService.language; // 2
  constructor(
    private modalCtrlr: ModalController,
    private dataController: CMSDataControllerService,
    public translateService: CodebaseTranslateService
  ) {}

  goBack() {
    this.modalCtrlr.dismiss();
  }
  ngOnInit() {
    this.dataController
      .getPages(
        { domainId: environment.cms.domainId },
        this.language ? this.language.value : "esp"
      )
      .subscribe((pages: any) => {
        //Home Menu.
        console.log(pages);
        this.page = pages.find((it) => {
          return (
            it.active &&
            it.rssLink &&
            it.rssLink === new DeepLinkHelper().getParkRssLink()
          );
        });
        console.log(this.page);
      });
  }

  onDirectionsClick() {
      window.open(`https://maps.app.goo.gl/6sFB92GSTYQ7VNst6`, '_blank');
  }
}
